import { RecallType } from '@navio/nsdk';
import type { NoddiIconName as IconName } from 'noddi-ui-common';
import { type FilterOption } from 'noddi-ui-web';
import { RECALL_TYPE_OPTIONS } from 'noddi-util';

const recallTypeIconMap: Record<RecallType, IconName> = {
  [RecallType.RECALL_PROPOSAL_TIRE_HOTEL]: 'Hotel',
  [RecallType.RECALL_PROPOSAL_WHEEL_CHANGE]: 'WheelAngle'
};

export const RECALL_TYPE_FILTER_OPTIONS: FilterOption<RecallType>[] = RECALL_TYPE_OPTIONS.map((opt) => ({
  ...opt,
  label: opt.label.replace('Recall proposal ', '').replace(/^\w/, (c) => c.toUpperCase()),
  icon: recallTypeIconMap[opt.value]
}));
